import './AttachmentListView.css';
import { jsx as t } from "react/jsx-runtime";
import a from "clsx";
import n from "react";
import { A as c } from "./AttachmentView-CgsYQoZZ.js";
const l = "_wrapper_fuxdj_1", u = "_item_fuxdj_10", m = {
  wrapper: l,
  item: u
}, w = ({
  attachments: o,
  className: r,
  itemClassName: s,
  ...i
}) => {
  const p = a({
    [m.wrapper]: !0,
    // Custom classes
    [String(r)]: !!r
  });
  return /* @__PURE__ */ t("ul", { className: p, children: o.map((e) => /* @__PURE__ */ t("li", { className: m.item, children: /* @__PURE__ */ t(c, { className: s, ...e, ...i }, e.uuid) }, e.uuid)) });
}, A = n.memo(w);
export {
  A
};
//# sourceMappingURL=AttachmentListView-DHZl-g6p.js.map
